/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import IndexedDB from "@/helpers/IndexedDB.js";
import store from "@/store";

export default {
	async changeNavbarColor({commit}, val) {
		try {
			commit("CHANGE_NAVBAR_COLOR", val);
		} catch (error) {
			console.error(error);
		}
	},
	async saveColorsOnIndexedDB({state, commit, dispatch}, color) {
		const {navbar_color, primary_color} = color;
		return new Promise((resolve, reject) => {
			(async () => {
				try {
					const userInfo = JSON.parse(localStorage.getItem("userInfo"));
					const val = await dispatch("validate", userInfo.uid);
					let primaryColor = "";
					let navbarColor = "";
					if (val) {
						primaryColor = primary_color || val.primaryColor;
						navbarColor = navbar_color || val.navbarColor;
						await IndexedDB.update("app_setting", {primaryColor, navbarColor}, userInfo.uid);
						commit("CHANGE_NAVBAR_COLOR", navbarColor);
						store.commit("UPDATE_PRIMARY_COLOR", primaryColor);
					} else {
						primaryColor = primary_color || store.state.themePrimaryColor;
						navbarColor = navbar_color || state.navbarColor;
						await IndexedDB.save("app_setting", {primaryColor, navbarColor}, userInfo.uid);
						commit("CHANGE_NAVBAR_COLOR", navbarColor);
						store.commit("UPDATE_PRIMARY_COLOR", primaryColor);
					}
					resolve({primaryColor, navbarColor});
				} catch (error) {
					console.error(error);
					reject(error);
				}
			})();
		});
	},
	validate({state, commit, dispatch}, uid) {
		return IndexedDB.getKey("app_setting", uid);
	},
};
